/* Header country/region selector (snippets/te-country-selector.liquid).
   Fills each <details> menu from the shared country list, then adds search,
   arrow keys and closing behavior. Picking a country is a plain form submit. */
(function () {
  "use strict";

  var ROOT = "[data-teh-cty]",
    FINE = window.matchMedia("(pointer: fine)"),
    DESK = window.matchMedia("(min-width: 1100px)"),
    ALIAS = {
      AE: "uae emirates",
      BA: "bosnia",
      CI: "ivory coast",
      CV: "cabo verde",
      CZ: "czech republic",
      DE: "deutschland",
      GB: "uk britain great britain england scotland wales northern ireland",
      KR: "korea",
      MK: "macedonia",
      MM: "burma",
      MO: "macau",
      NL: "holland",
      PS: "palestine",
      SZ: "swaziland",
      TL: "east timor",
      TR: "turkey",
      US: "usa america united states of america",
      VA: "holy see"
    };

  function $$(sel, ctx) {
    return Array.prototype.slice.call((ctx || document).querySelectorAll(sel));
  }

  function closestBox(el) {
    return el && el.closest ? el.closest(ROOT) : null;
  }

  // "Côte d’Ivoire" -> "cote divoire", "Bosnia & Herzegovina" -> "bosnia and herzegovina"
  function norm(s) {
    s = String(s || "").toLowerCase();
    if (s.normalize) s = s.normalize("NFD").replace(/[̀-ͯ]/g, "");
    return s.replace(/&/g, " and ").replace(/[-/]/g, " ").replace(/[^a-z0-9 ]+/g, "").replace(/\s+/g, " ").trim();
  }

  function setup(box) {
    if (box.tehCty) return box.tehCty;
    // The list is printed once in <template id="TehCountryList">; copy it in on first open.
    var list = box.querySelector("[data-teh-cty-list]"),
      tpl = document.getElementById("TehCountryList");
    if (list && !list.firstElementChild && tpl && tpl.content) list.appendChild(tpl.content.cloneNode(true));
    box.tehCty = {
      q: box.querySelector("[data-teh-cty-q]"),
      status: box.querySelector("[data-teh-cty-status]"),
      none: box.querySelector("[data-teh-cty-none]"),
      list: list,
      grps: $$("[data-teh-cty-grp]", box),
      opts: $$(".teh-cty-o", box).map(function (btn) {
        var name = btn.querySelector(".teh-cty-n"),
          cur = btn.querySelector(".teh-cty-c"),
          words = norm(name ? name.textContent : "").split(" ");
        if (words.indexOf("st") > -1) words.push("saint");
        words.push(btn.value.toLowerCase());
        if (cur) words.push(norm(cur.textContent).split(" ")[0]);
        if (ALIAS[btn.value]) words = words.concat(ALIAS[btn.value].split(" "));
        return { btn: btn, li: btn.parentNode, words: words };
      })
    };
    return box.tehCty;
  }

  // Every typed word has to start one of the country's words: "new z", "united k", "eur".
  function filter(box) {
    var st = setup(box),
      tokens = norm(st.q ? st.q.value : "").split(" ").filter(Boolean),
      count = 0;
    st.opts.forEach(function (o) {
      var hit = tokens.every(function (t) {
        return o.words.some(function (w) {
          return w.indexOf(t) === 0;
        });
      });
      o.li.hidden = !hit;
      if (hit) count++;
    });
    st.grps.forEach(function (g) {
      g.hidden = !g.querySelector("li:not([hidden])");
    });
    if (st.none) st.none.hidden = count > 0;
    if (st.status) st.status.textContent = tokens.length ? (count === 0 ? "No results" : count === 1 ? "1 result" : count + " results") : "";
  }

  function shown(st) {
    return st.opts
      .filter(function (o) {
        return !o.li.hidden;
      })
      .map(function (o) {
        return o.btn;
      });
  }

  function close(box, refocus) {
    if (!box.open) return;
    box.open = false;
    if (refocus) {
      var summary = box.querySelector("summary");
      if (summary) summary.focus();
    }
  }

  function closeAll(except) {
    $$(ROOT + "[open]").forEach(function (box) {
      if (box !== except) close(box);
    });
  }

  // toggle doesn't bubble, so listen in the capture phase. The drawer copy is cloned from a <template> later.
  document.addEventListener(
    "toggle",
    function (e) {
      var box = e.target;
      if (!box.matches || !box.matches(ROOT) || !box.open) return;
      closeAll(box);
      var st = setup(box);
      box.classList.remove("is-busy");
      if (st.q) {
        st.q.value = "";
        filter(box);
      }
      if (st.list) st.list.scrollTop = 0;
      if (st.q && FINE.matches) st.q.focus({ preventScroll: true });
    },
    true
  );

  document.addEventListener("input", function (e) {
    if (e.target.matches && e.target.matches("[data-teh-cty-q]")) {
      var box = closestBox(e.target);
      if (box) filter(box);
    }
  });

  // Capture phase, so Esc closes this menu before the drawer's own Esc handler closes the drawer.
  document.addEventListener(
    "keydown",
    function (e) {
      var box = closestBox(e.target);
      if (!box || !box.open) return;
      var st = setup(box),
        key = e.key,
        list = shown(st),
        i = list.indexOf(e.target);
      if (key === "Escape") {
        e.preventDefault();
        e.stopPropagation();
        close(box, true);
      } else if (e.target === st.q) {
        if (key === "ArrowDown" && list[0]) {
          e.preventDefault();
          list[0].focus();
        } else if (key === "Enter") {
          // Without this, Enter would submit the form with the first country in the list.
          e.preventDefault();
          if (st.q.value.trim() && list[0]) list[0].click();
        }
      } else if (e.target.tagName === "SUMMARY") {
        if (key === "ArrowDown" && (st.q || list[0])) {
          e.preventDefault();
          (st.q || list[0]).focus();
        }
      } else if (i > -1) {
        if (key === "ArrowDown") {
          e.preventDefault();
          if (list[i + 1]) list[i + 1].focus();
        } else if (key === "ArrowUp") {
          e.preventDefault();
          (list[i - 1] || st.q || list[0]).focus();
        } else if (key === "Home") {
          e.preventDefault();
          list[0].focus();
        } else if (key === "End") {
          e.preventDefault();
          list[list.length - 1].focus();
        } else if (st.q && key.length === 1 && key !== " " && !e.ctrlKey && !e.metaKey && !e.altKey) {
          st.q.focus();
        }
      }
    },
    true
  );

  document.addEventListener("pointerdown", function (e) {
    $$(ROOT + "[open]").forEach(function (box) {
      if (!box.contains(e.target)) close(box);
    });
  });

  document.addEventListener("focusout", function (e) {
    var box = closestBox(e.target);
    if (box && box.open && e.relatedTarget && !box.contains(e.relatedTarget)) close(box);
  });

  document.addEventListener("submit", function (e) {
    var box = e.target.querySelector ? e.target.querySelector(ROOT) : null;
    if (box) box.classList.add("is-busy");
  });

  window.addEventListener("pageshow", function (e) {
    if (!e.persisted) return;
    $$(ROOT).forEach(function (box) {
      box.classList.remove("is-busy");
      close(box);
    });
  });

  if (DESK.addEventListener) {
    DESK.addEventListener("change", function () {
      closeAll();
    });
  } else if (DESK.addListener) {
    DESK.addListener(function () {
      closeAll();
    });
  }
})();
